/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum MessageTypeEnum {
    Info,
    Warning,
    Error,
    Success,
    PerformingAction
}
